import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submenu"];

  connect() {
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  toggle(event) {
    event.stopPropagation();

    if (this.submenuTarget.classList.contains("hidden")) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.closeSiblings();
    this.submenuTarget.classList.remove("hidden");
    this.positionSubmenu();
    document.addEventListener("click", this.handleOutsideClick);
  }

  close() {
    this.submenuTarget.classList.add("hidden");
    this.resetPosition();
    document.removeEventListener("click", this.handleOutsideClick);
  }

  // The panel defaults to opening rightward (see the ERB). But a caller like the "Add Content"
  // button sits at the right edge of the report-dashboard header, so a right-opening panel there
  // would run past the viewport edge with its items visually sheared off. Measure at open time
  // (the panel is `hidden` until now, so it can't be measured earlier) and flip left only when
  // there isn't room on the right.
  positionSubmenu() {
    const panel = this.submenuTarget;
    const rect = panel.getBoundingClientRect();

    // Only a RIGHT-OPENING panel flips. One that opens downward (left-0 top-full) has no left-full to
    // trade away, so flipping it would add right-full on top of its own positioning and leave the two
    // fighting; the reset then has nothing to undo because it never owned those classes.
    if (rect.right > window.innerWidth && panel.classList.contains("left-full")) {
      this.flipped = true;
      panel.classList.remove("left-full", "ml-1");
      panel.classList.add("right-full", "mr-1");
    }

    const overflowY = panel.getBoundingClientRect().bottom - window.innerHeight;
    if (overflowY > 0) {
      panel.style.top = `-${overflowY}px`;
    }
  }

  resetPosition() {
    const panel = this.submenuTarget;
    if (this.flipped) {
      panel.classList.remove("right-full", "mr-1");
      panel.classList.add("left-full", "ml-1");
      this.flipped = false;
    }
    panel.style.top = "";
  }

  // Only one submenu at a given level should be open at a time.
  closeSiblings() {
    const parent = this.element.parentElement;
    if (!parent) return;

    Array.from(parent.children).forEach((sibling) => {
      if (sibling === this.element) return;

      this.application
        .getControllerForElementAndIdentifier(sibling, this.identifier)
        ?.close();
    });
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }

  disconnect() {
    document.removeEventListener("click", this.handleOutsideClick);
  }
}
